export const formatDate = (isoDate: string): string => {
  const options: Intl.DateTimeFormatOptions = {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  }
  return new Date(isoDate).toLocaleDateString('en-US', options)
}
export const updatedAtDateFormat = (date: string): string => {
  const dateFormat = new Date(date)
  return `${dateFormat.getDate().toString().padStart(2, '0')}/${(dateFormat.getMonth() + 1).toString().padStart(2, '0')}/${dateFormat.getFullYear()}`
}
export const joinedAtDateFormat = (date: string): string => {
  const dateFormat = new Date(date)
  return `${dateFormat.toLocaleString('en-US', { month: 'short' })} ${dateFormat.getFullYear()}`
}

export const formatTimestamp = (timestampString: string): string => {
  const timestamp = new Date(timestampString)
  const options: Intl.DateTimeFormatOptions = {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  }
  const formattedDate = timestamp.toLocaleDateString('en-US', options)
  const array = formattedDate.split(' ')
  return array[1] + ' ' + array[0] + ' ' + array[2]
}
